import { SegmentBase } from '../../visibility/SegmentBase';
export class ObstacleSide extends SegmentBase {
    Init(sv) {
        this.StartVertex = sv;
    }
    constructor(startVertex) {
        super();
        this.Init(startVertex);
    }
    get Polyline() {
        return this.StartVertex.polyline;
    }
    get Start() {
        return this.StartVertex.point;
    }
    get End() {
        return this.EndVertex.point;
    }
}
//# sourceMappingURL=ObstacleSide.js.map